import React, { useState } from 'react';
import tips from 'assets/images/campaign/recurring_campaign_description.png';
import CustomSwitchButton from 'components/base/CustomSwitchButton';
import { Image, Modal, Button } from 'react-bootstrap';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import './RecurringCampaignSwitch.scss'

const RecurringCampaignSwitch = ({
  setValue,
  defaultValue,
}) => {
  const [showRecurringDescription, setShowRecurringDescription] = useState(false)
  return (
    <div className="d-flex flex-column">
      <div>
        <CustomTitleLabel title={"This is a recurring campaign for birthday"} />
        <label className="btn-link reset-button clickable-field" onClick={() => setShowRecurringDescription(true)}>Learn more</label>
      </div>
      <label className="tips-message">
        If ON, the system will auto-apply this rule to the customers who have birthday in current month.
      </label>
      <CustomSwitchButton
        defaultChecked={defaultValue}
        onChange={(isChecked) => {
          setValue(isChecked)
        }}
      />
      <Modal
        show={showRecurringDescription}
        onHide={() => setShowRecurringDescription(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Body
          className={`base-prompt-container`}
        >
          <Image src={tips} alt='describe campaign recurring info' className='recurring-campaign-learn-more-pop' />
          <Button
            className={'base-continue-button base-save-and-back-component-button btn-further'}
            onClick={() => {
              setShowRecurringDescription(false)
            }}
          >
            OK
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default RecurringCampaignSwitch